module.exports = __webpack_public_path__ + "static/media/教学机.6af5254d.png";